
export default function ProcessSection() {
  const steps = [
    {
      number: '1',
      title: 'Reunião Confidencial',
      description: 'Você conta tudo sem julgamento. Escutamos sua história com empatia e profissionalismo.',
      icon: 'ri-user-heart-line'
    },
    {
      number: '2',
      title: 'Planejamento Estratégico',
      description: 'Criamos um plano personalizado para seu caso específico, considerando rotina e hábitos.',
      icon: 'ri-roadmap-line'
    },
    {
      number: '3',
      title: 'Investigação Discreta',
      description: 'Coletamos evidências de forma totalmente invisível. Seu parceiro NUNCA descobrirá.',
      icon: 'ri-spy-line'
    },
    {
      number: '4',
      title: 'Coleta e Organização',
      description: 'Organizamos todas as evidências de forma profissional e juridicamente válida.',
      icon: 'ri-folder-line'
    },
    {
      number: '5',
      title: 'Relatório Final',
      description: 'Entregamos resposta irrefutável + orientação sobre próximos passos.',
      icon: 'ri-file-text-line'
    }
  ];

  return (
    <section id="processo" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Processo 100% Transparente
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Nosso método <strong>comprovado em 5 etapas</strong> garante resultados precisos 
            com total discrição e profissionalismo.
          </p>
        </div>

        <div className="relative">
          {/* Linha conectora */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-red-200 transform -translate-y-1/2"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="text-center">
                  {/* Número da etapa */}
                  <div className="w-16 h-16 bg-red-600 text-white rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4 relative z-10">
                    {step.number}
                  </div>
                  
                  {/* Ícone */}
                  <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${step.icon} text-red-600 text-xl`}></i>
                  </div>
                  
                  {/* Conteúdo */}
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="bg-white p-8 rounded-lg shadow-md max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Tempo Médio: 7 a 15 dias
            </h3>
            <p className="text-gray-700 mb-6">
              Dependendo da complexidade do caso, você terá <strong>respostas definitivas</strong> 
              em no máximo 2 semanas.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <div className="flex items-center text-green-600">
                <i className="ri-shield-check-line mr-2"></i>
                <span className="font-medium">100% Confidencial</span>
              </div>
              <div className="flex items-center text-green-600">
                <i className="ri-eye-off-line mr-2"></i>
                <span className="font-medium">Totalmente Discreto</span>
              </div>
              <div className="flex items-center text-green-600">
                <i className="ri-file-text-line mr-2"></i>
                <span className="font-medium">Evidências Profissionais</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
